import { Flex, Stack } from "@chakra-ui/react";
import SkeletonBox from "./SkeletonBox";

const SkeletonCategorySelection: React.FC = () => (
  <Stack gap={3} mt={3}>
    {Array.from({ length: 2 }).map((_, index) => (
      <Stack key={index} gap={3}>
        <Flex gap={3}>
          <SkeletonBox h={5} w={5} />
          <SkeletonBox h={5} w={200} />
        </Flex>

        {Array.from({ length: 4 }).map((_, index) => (
          <Flex key={index} gap={3} position="relative" left={10}>
            <SkeletonBox h={5} w={5} />
            <SkeletonBox h={5} w={180} />
          </Flex>
        ))}
      </Stack>
    ))}

    <SkeletonBox borderRadius={20} h="40px" w="100%" maxWidth={200} mt={5} />
  </Stack>
);

export default SkeletonCategorySelection;
